import { Component, DestroyRef, inject, OnInit, ViewEncapsulation } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { AlertService } from "../../services/alert.service";
import { Alert } from "../../models/alert";
import { Observable } from "rxjs";
import { AsyncPipe } from "@angular/common";

@Component({
    selector: "app-alert-display",
    templateUrl: "./alert-display.component.html",
    styleUrls: ["./alert-display.component.scss"],
    encapsulation: ViewEncapsulation.None,
    imports: [AsyncPipe],
})
export class AlertDisplayComponent implements OnInit {
    public alerts$: Observable<Alert[]>;
    private destroyRef = inject(DestroyRef);

    constructor(private alertService: AlertService) {
        this.alerts$ = this.alertService.alertSubject.asObservable();
    }

    ngOnInit(): void {
        this.alertService.dismissSubject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((alert) => this.closeAlert(alert));
        this.observeHeaderHeight();
    }

    // Toasts sit top-right, just below the header. The header (header-nav) is in normal flow
    // and its height is responsive, so track it and expose --header-height for the offset.
    private observeHeaderHeight(): void {
        const header = document.querySelector("header-nav");
        if (!header) return;
        const observer = new ResizeObserver((entries) => {
            const height = entries[0].borderBoxSize?.[0]?.blockSize ?? entries[0].contentRect.height;
            document.documentElement.style.setProperty("--header-height", `${height}px`);
        });
        observer.observe(header);
        this.destroyRef.onDestroy(() => observer.disconnect());
    }

    public closeAlert(alert: Alert): void {
        if (alert.exiting) return;
        alert.exiting = true;
        this.alertService.alertSubject.next([...this.alertService.alerts]);
        setTimeout(() => this.alertService.removeAlert(alert), 400);
    }
}
